import React, { useEffect, useCallback, useState} from 'react';
import {setTrackBrowsedSamples} from 'actions/index.js';
import {connect} from 'react-redux';

const SamplesBreadcrumb = ({track, sample, samples=[], setBrowsedSamples}) => { 
    const onClick = useCallback((s) => {
        track.auditionSound(s, undefined, undefined, false);
    }, [track]);

    const onClickPrev = useCallback(() => {
        let index = samples.indexOf(sample);
        index++;
        let s = samples[index];
        if (s) {
            onClick(s);
        }
    }, [track, samples, sample]);

    const onClickNext = useCallback(() => {
        let index = samples.indexOf(sample);
        index--;
        let s = samples[index];
        if (s) {
            onClick(s);
        }
    }, [track, samples, sample]);

    const getClassName = useCallback((x) => {
        if (x === sample) {
            return "sample-option selected";
        }
        return "sample-option";
    }, [sample]);

    let index = samples.indexOf(sample);
    let len = samples.length;

    let nextClass = "next-button";
    let prevClass = "previous-button";

    if (index >= len - 1) {
        prevClass += " disabled";
    }

    if (index < 1) {
        nextClass += " disabled";
    }

    return (
        <div>
          <div className="fwd-back-buttons">
            <div
              onClick={onClickPrev}
              className={prevClass}/>
            <div
              onClick={onClickNext}
              className={nextClass}/>
          </div>
          <div className="samples-breadcrumb">
            {samples.map(
                x =>
                    <div
                      onClick={() => onClick(x)}
                      className={getClassName(x)}>
                      {x.name} ( 
                      {x.tags ? x.tags.join(", ") : ""})
                    </div>)}
            
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      samples: state.tracks.trackBrowsedSamples[props.track.id],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setBrowsedSamples: (samples) => dispatch(
          setTrackBrowsedSamples(props.track.id, samples))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplesBreadcrumb);
